// Get the current URL pathname
export const pathname = window.location.pathname;

// Extract the first path segment
export const firstSegmentPath = pathname.split("/").filter(Boolean)[0]; 
